import { ColDef } from '@ag-grid-enterprise/all-modules'
import { initialCrudModelBaseState, CrudModelPaginatorLaboratory } from '@/shared/models/cruds.models'
import { AgGridColumnType } from '@/shared/models/ag-grid.model'
import i18n from '@/lang/i18n'
import { ConfigurationShelfSampleTypeAssignmentResponse } from '@/modules/configurationModule/detail/automation/grossing-shelf/sample-type-and-shelf/services/configuration-shelf-sample-type-assignment/configuration-shelf-sample-type-assignment.dto'
import { configurationShelfSampleTypeAssignmentService } from '@/modules/configurationModule/detail/automation/grossing-shelf/sample-type-and-shelf/services/configuration-shelf-sample-type-assignment/configuration-shelf-sample-type-assignment.service'
import { PaginatorLaboratoryDatasource } from '@/shared/resources/datasources/paginator/paginator-laboratory-datasource'
import { VIRTUAL_SHELF_OPTIONS_GROSSING_SAMPLE } from '@/modules/grossingModule/services/grossingSampleService'
import { store } from '@/store/store'

export const columnsDefAutomationGrossingShelfSampleTypeAndShelfGrid =
    (): ColDef[] => [
        { type: AgGridColumnType.CUSTOM_CHECKBOX },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.sections.sampleType'),
            field: 'sampleType.description',
            flex: 1,
            minWidth: 400,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.SAMPLE_VIRTUAL_SHELF,
            headerName: i18n.tc('configuration.sections.grossingShelf'),
            field: 'virtualShelf.code',
            colId: 'virtualShelf',
            flex: 1,
            minWidth: 400,
            suppressSizeToFit: true,
            filterParams: {
                values: VIRTUAL_SHELF_OPTIONS_GROSSING_SAMPLE.map(virtualShelf => virtualShelf.code)
            }
        }
    ]

export interface ConfigurationAutomationGrossingShelfSampleTypeAndShelfGridState extends CrudModelPaginatorLaboratory<ConfigurationShelfSampleTypeAssignmentResponse> {
    service: typeof configurationShelfSampleTypeAssignmentService
    laboratoryId: number
}
export const initialConfigurationAutomationGrossingShelfSampleTypeAndShelfGridState =
    (): ConfigurationAutomationGrossingShelfSampleTypeAndShelfGridState => ({
        ...initialCrudModelBaseState(),
        gridUiComponent: 'uicomponent.configuration.local.automation.grossingShelf.sampleTypeAndShelf',
        columnsDef: columnsDefAutomationGrossingShelfSampleTypeAndShelfGrid(),
        datasource: new PaginatorLaboratoryDatasource(configurationShelfSampleTypeAssignmentService, store.getters.labId),
        service: configurationShelfSampleTypeAssignmentService,
        laboratoryId: store.getters.labId
    })
